import Actions from '../../odata/actions';

const actions = new Actions('mapQuery', 'mapQueries');

export default actions;
